import {IServiceFactoryExtended} from "../../service-factory-extended.interface";
import {AIGamesRecommendations} from "../ai-recommendations-reader.service.interface";
import {reaction} from "mobx";

const EMPTY_RECOMMENDATIONS_CACHE: AIGamesRecommendations = {
    engine: null,
    gameTypes: []
}

export abstract class GamesRecommendationsBaseModel {
    constructor(protected readonly services: IServiceFactoryExtended) {
        reaction(() => this.services.user.isAuthorized, () => {
            this._cache = null;
        });
    }

    protected abstract _readGamesRecommendationsFromServer(): Promise<AIGamesRecommendations>;
    protected abstract get localStorageKey(): string;

    private _cache: AIGamesRecommendations | null = null;

    async getRecommendations(): Promise<AIGamesRecommendations> {
        if(!this.services.user.isAuthorized) {
            return this._tryGetRecommendationsFromLocalStorage();
        }

        if(this._cache) {
            return this._cache;
        }

        try {
            this._cache = await this._readGamesRecommendationsFromServer();

            this.services.localStorage.setJson(this.localStorageKey, this._cache);
            return this._cache;
        } catch (err) {
            this.services.logger.error(`Failed to read games recommendations! Recommendations identifier: ${this.localStorageKey}`, err);
            return EMPTY_RECOMMENDATIONS_CACHE;
        }
    }


    private _tryGetRecommendationsFromLocalStorage(): AIGamesRecommendations {
        const storedData = this.services.localStorage.getJson<AIGamesRecommendations>(this.localStorageKey);
        if(storedData) {
            return storedData;
        }

        return EMPTY_RECOMMENDATIONS_CACHE;
    }




}